export const BASE_PATH = '/bank'

const tifiRoutes = {
  HOME: `${BASE_PATH}/`,
  SWAP: `${BASE_PATH}/swap`,
  STAKE: `${BASE_PATH}/stake`,
  STAKE_LOCK: `${BASE_PATH}/lock_to_earn`,
  PORTFOLIO: `${BASE_PATH}/portfolio`,
  PORTFOLIO_POOL: `${BASE_PATH}/portfolio/portfolio_pool`,
  PORTFOLIO_STAKE: `${BASE_PATH}/portfolio/portfolio_stake`,
  PORTFOLIO_LUCKYBAGS: `${BASE_PATH}/portfolio/portfolio_lucky_bags`,
  LIQUIDITY: `${BASE_PATH}/liquidity`,
  LOAN: `${BASE_PATH}/loan`,
  LOANDEPOSIT: `${BASE_PATH}/loan/deposit`,
  LOANWITHDRAW: `${BASE_PATH}/loan/withdraw`,
  LOANBORROW: `${BASE_PATH}/loan/borrow`,
  LOANREPAY: `${BASE_PATH}/loan/repay`,
  LOTTERY: `${BASE_PATH}/win`,
  FIAT: "https://track.swipelux.com/?api-key=547b3a8a-d2b8-4492-ad1a-6aae1b929c45",
};

export default tifiRoutes;